import React from 'react'
import Manager from '../../public/components/Manager'
import OverTimeApplyDetail from './OverTimeApplyDetail'
import { reconfigButton, nullDate, TDate, getListFromValues } from '../../../src/public/utility'
import OverTimeApplyBatchDiv from '../../business/OverTimeApplyBatchDiv'

Ext.require('Ext.Toast')
const disableBatch = ({ state: { selected = null } }) => !selected || !selected.length

const config = () => {
    const handelBatchAction = ({ showDetail, refreshPage, state: { selected }, props: { dispatch } }, title, action) => {
        const list = selected && selected.map(o => o.data.id) || []
        Tyan.pubForm.showDialog(title, props => <OverTimeApplyBatchDiv {...props} ids={list} action={action} onSave={refreshPage} />)
    }
    const tiptools = [{
        _tool: '', icon: 'info-circle', ui: 'action', tooltip: o => (
            `
            员工编号:${o['员工编号']}<br>
            员工姓名:${o['员工姓名']}<br>
            部门名称:${o['部门名称']}<br>
            职务名称:${o['职务名称']}<br>
            加班开始时间:${o['加班开始时间'] && o['加班开始时间'] != nullDate && new TDate(o['加班开始时间']).toString('yyyy/MM/dd HH:mm') || ''}<br>
            加班结束时间:${o['加班结束时间'] && o['加班结束时间'] != nullDate && new TDate(o['加班结束时间']).toString('yyyy/MM/dd HH:mm') || ''}<br>
            加班时长:${o['加班时长（h）']}<br>
            加班折算方式:${o['加班折算方式']}<br>
            服务单位:${o['服务单位']}<br>
            加班原因:${o['加班原因']}<br>
            备注:${o['备注']}
            `
        )
    }]
    return {
        multiSelect: true,
        buttons: [
            {
                text: '确定', handler: that => handelBatchAction(that, '提交', '提交'), disabled: disableBatch
            },
            {
                text: '驳回申请', handler: that => handelBatchAction(that, '驳回申请', '退回申请'), disabled: disableBatch
            },
        ],
        columns: [
            { _text: '申请编号', field: 'Number', minWidth: 250, search: true, tools: tiptools },
            { _text: '加班折算方式', field: 'ConversionMode', minWidth: 150, search: true, filter: ['select'], },
            { _text: '申请人', field: 'Creator', minWidth: 150, search: true, },
            { _datetime: '加班开始时间', field: 'PlanStartTime', minWidth: 150, filter: true, align: 'left', },
            { _datetime: '加班结束时间', field: 'PlanEndTime', minWidth: 150, filter: true, align: 'left', },
            { _number: '加班时长（h）', field: 'PlanHours', minWidth: 150, filter: true, },
            { _text: '加班原因', field: 'Reason', minWidth: 150, flex: 10, search: true },
            { _text: '状态名称', field: 'StatusName', minWidth: 150, flex: 10, search: true, filter: ['select'], },
            { _: '员工编号', field: 'Person.PersonNo' },
            { _: '员工姓名', field: 'Person.ActualName' },
            { _: '部门名称', field: 'Person.Dep.ShortName' },
            { _: '职务名称', field: 'Person.PersonDuty' },
            { _: '加班折算方式', field: 'ConversionMode' },
            { _: '服务单位', field: 'ServiceUnit' },
            { _: '备注', field: 'Remark' },
            { _: 'taskName', field: 'Task.TaskName' }
        ],
        onDoubleTap: ({ showDetail, refreshPage }, data) => {
            showDetail(props => <OverTimeApplyDetail {...props} id={data.id} taskName={data.taskName} />)
        }
    }
}

export default props => <Manager {...props} config={config} />